import { CodeEspece } from '../../declaration/models/enums/code-espece.enum';

export class EstimationEcoulement {
    static jsonMap = {
        espece: { key: 'codeEspece' },
        idGroupeVarietal: { key: 'idGroupeVarietal' },
        groupeVarietal: { key: 'groupeVarietal' },
        estimation: { key: 'estimation' }
    };

    public espece: string;
    public idGroupeVarietal: number;
    public groupeVarietal: string;
    public estimation: number;

    sorting(): string {
        return ''.concat(
            this.espece === CodeEspece.POMME ? '0' : this.espece === CodeEspece.POIRE ? '1' : '2',

            this.groupeVarietal.toUpperCase()
        );
    }
}
